import { ApmService } from '@elastic/apm-rum-angular';
import { environment } from './environments/environment';

export function initApm(apm: ApmService) {
    apm.init({
        serviceName: 'formwiz-signpl-angular',
        serverUrl: 'https://apm.signpl.com',
        environment:
            environment.env === 'prod' || environment.env === 'prod-admin'
                ? 'production'
                : 'development',
        transactionSampleRate: 0.2,
        distributedTracingOrigins: [
            'https://coreapi.signpl.com/',
            // Add more backend origins here.
        ],
        // Custom interceptor-based request transactions already capture API traffic.
        // Disabling automatic network instrumentation prevents duplicate request entries.
        disableInstrumentations: ['fetch', 'xmlhttprequest'],
        propagateTracestate: true,
        logLevel: 'error',
    });

    return () => { };
}